import { nonNull } from "common/Support";
import * as React from "react";
import { createPortal } from "react-dom";
import { styled } from "sharedUI/styles";
import ClickOutsideContainer from "sharedUI/ui/smart/click-outside-container/click-outside-container";

interface BaseModalV2Props {
    readonly canClickOff: boolean;
    readonly onClickOff?: () => void;

    readonly className?: string;
}

const BaseModalV2Style = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: ${p => p.theme.modals.backgroundTint};

    .bm-content-area {
        position: absolute;
        left: 50%;
        top: 50%;

        transform: translateX(-50%) translateY(-50%);
    }
`;

const BaseModalV2: React.FunctionComponent<BaseModalV2Props> = p => {
    const { children, canClickOff, onClickOff, className } = p;

    const onClickOffImpl = React.useCallback(() => {
        if (canClickOff && onClickOff !== undefined) {
            onClickOff();
        }
        return;
    }, [canClickOff, onClickOff]);

    const content = (
        <BaseModalV2Style className={className}>
            <ClickOutsideContainer onClickOutside={onClickOffImpl}>
                <div className="bm-content-area">{children}</div>
            </ClickOutsideContainer>
        </BaseModalV2Style>
    );

    return createPortal(content, nonNull(document.getElementById("portal")));
};
export default BaseModalV2;
